/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'PrincipalProfile', '$http', 'AlertService'];

    function HomeController ($scope, Principal, LoginService, $state, PrincipalProfile, $http, AlertService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.limited = true;
        vm.initLimit = 3;
        vm.limit = vm.initLimit;
        vm.dataExport = dataExport;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.isAuthenticated()) {
                    PrincipalProfile.identity(true).then(function(profile) {
                        vm.profile = profile;
                    });
                    getInstructorOverview();
                    getSksTripSkipperOverview();
                }
            });
        }

        function register () {
            $state.go('register');
        }

        function getInstructorOverview() {
            $http.get('api/member/sbf-time-slots/overview/', {}).then(function(response) {
                vm.instructorOverview = response.data;
            });
        }

        function getSksTripSkipperOverview() {
            $http.get('api/member/projects/sksTrip/', {}).then(function(response) {
                vm.sksSkipperOverview = response.data;
            });
        }

        vm.toggleLimit = function() {
            vm.limited = !vm.limited;
            if(vm.limited) {
                vm.limit = vm.initLimit;
            } else {
                vm.limit = vm.instructorOverview.length;
            }
        };

        function dataExport(projectId) {
            vm.isSaving = true;
            $http.get('api/member/projects/sksTrip/export/', {params: {
                    projectId: projectId
                }}).then(function(response) {
                vm.isSaving = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }
    }
})();
